var isHTTPS = location.protocol == 'https:'
if (isHTTPS) {
    module.exports = {
        http_server: 'http://120.55.199.144:8101/api/',
        https: 'https://wechat.yaduo.com/',
        share_https: 'http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=',
        java_server: 'https://api2.yaduo.com/'
    }
} else {
    module.exports = {
        http_server: 'http://120.55.199.144:8101/api/',
        https: 'http://wechat.yaduo.com/',
        share_https: 'http://121.42.145.235:9001/api/meb/GetCommonConfigByWechat?paramName=ebf4d1&isCorp=false&pageUrl=',
        java_server: 'http://api2.yaduo.com/'
    }
}


//////////////////
// WEBPACK FOOTER
// ./build/config/prd.js
// module id = 58
// module chunks = 2